/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BlockIcon32Regular = forwardRef('BlockIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13S23.18 3 16 3ZM8.96 7.547A10.955 10.955 0 0 1 16 5c6.075 0 11 4.925 11 11 0 2.677-.957 5.132-2.547 7.04L8.961 7.546ZM7.548 8.96A10.956 10.956 0 0 0 5 16c0 6.075 4.925 11 11 11 2.677 0 5.131-.957 7.039-2.547L7.547 8.961Z" })));
});
